import { FC } from 'react';
import { ListItem, UnorderedList } from '@chakra-ui/react';

import Callout from 'components/_core/Callout';
import Text from 'components/_core/Text';
import Header from 'features/Onboarding/components/Header';

import locales from './locales';

const MORE_INFO_LINK =
  'https://help.shine.fr/fr/articles/4305211-qu-est-ce-qu-un-beneficiaire-effectif';

interface CapitalDepositHeaderProps {
  hideBody?: boolean;
}

const CapitalDepositHeader: FC<CapitalDepositHeaderProps> = ({
  hideBody = false,
}) => (
  <Header
    description={
      hideBody ? undefined : (
        <>
          <Text>{locales.description}</Text>
          <Callout marginTop="space-16">
            <UnorderedList>
              <ListItem>
                <Callout.Content>{locales.infoLine1}</Callout.Content>
              </ListItem>
              <ListItem>
                <Callout.Content>{locales.infoLine2}</Callout.Content>
              </ListItem>
              <ListItem>
                <Callout.Content>{locales.infoLine3}</Callout.Content>
              </ListItem>
            </UnorderedList>
          </Callout>
        </>
      )
    }
    linkText={hideBody ? undefined : locales.beneficiaryFaqLink}
    linkUrl={hideBody ? undefined : MORE_INFO_LINK}
    title={locales.title}
  />
);

export default CapitalDepositHeader;
